import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';
import './assets/css/Animations.css';

// Import pages
import HomePage from './pages/HomePage';
import EventsListPage from './pages/EventsListPage';
import EventPage from './pages/EventPage';
import DetailsPage from './pages/DetailsPage';
import RegisterPage from './pages/RegisterPage';
import FAQPage from './pages/FAQPage';
import AdminPage from './pages/AdminPage';
import CheckInPage from './pages/CheckInPage';
import LoginPage from './pages/LoginPage';
import AppointmentPage from './pages/AppointmentPage';
import AppointmentsAdminPage from './pages/AppointmentsAdminPage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <div className="App" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1 }}>
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/events" element={<EventsListPage />} />
          <Route path="/event/:eventId" element={<EventPage />} />
          <Route path="/details" element={<DetailsPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/register/:eventId" element={<RegisterPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/appointments" element={<AppointmentPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/check-in"
            element={
              <ProtectedRoute>
                <CheckInPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/appointments"
            element={
              <ProtectedRoute>
                <AppointmentsAdminPage />
              </ProtectedRoute>
            }
          />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;